import { Injectable } from '@angular/core';
import { OpsSocketCommands } from 'ops/common/ops-alarm/websocket-message';
import { SocketMiddlewareService } from './socket-middleware.service';

@Injectable({
    providedIn: 'root',
})
export class SocketService {
    lastJoined: string = '';
    constructor(private socketService: SocketMiddlewareService) {}

    onNewAlarm() {
        return this.socketService.receiveMessageObserver(OpsSocketCommands.OccuredAlarmData);
    }

    onAlarmRecovered() {
        return this.socketService.receiveMessageObserver(OpsSocketCommands.RecoveredAlarmData);
    }
}
